import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";

export default function SetPassword() {
  const [token, setToken]       = useState("");
  const [prenom, setPrenom]     = useState("");
  const [email, setEmail]       = useState("");
  const [pass, setPass]         = useState("");
  const [conf, setConf]         = useState("");
  const [status, setStatus]     = useState("");
  const [msg, setMsg]           = useState("");
  const [step, setStep]         = useState("password");
  const [qr, setQr]             = useState("");
  const [secret, setSecret]     = useState("");
  const [mfaCode, setMfaCode]   = useState("");
  const [mfaError, setMfaError] = useState("");
  const [loading, setLoading]   = useState(false);

  useEffect(()=>{
    const params = new URLSearchParams(window.location.search);
    const t = params.get("token");
    if (!t) { setMsg("Lien invalide"); return; }
    setToken(t);
    fetch(`${BASE}/auth/token-info?token=${t}`)
      .then(r=>r.json())
      .then(d=>{
        if (d.error) setMsg(d.error);
        else { setPrenom(d.prenom||""); setEmail(d.email||""); }
      })
      .catch(()=>setMsg("Erreur de connexion"));
  },[]);

  const createPassword = async () => {
    if (pass.length<8) return setMsg("Minimum 8 caractères");
    if (pass!==conf) return setMsg("Les mots de passe ne correspondent pas");
    setLoading(true); setMsg("");
    try {
      const res = await fetch(`${BASE}/auth/set-password`,{
        method:"POST", headers:{"Content-Type":"application/json"},
        body:JSON.stringify({token, password:pass})
      }).then(r=>r.json());
      setLoading(false);
      if (res.ok && res.mfa_setup) {
        setQr(res.qr); setSecret(res.secret); setStep("mfa");
      } else if (res.error) {
        setMsg(res.error);
      }
    } catch(e){ setLoading(false); setMsg("Erreur serveur"); }
  };

  const confirmMFA = async () => {
    if (mfaCode.length!==6) return setMfaError("Code à 6 chiffres requis");
    setLoading(true); setMfaError("");
    try {
      const res = await fetch(`${BASE}/auth/confirm-mfa-setup`,{
        method:"POST", headers:{"Content-Type":"application/json"},
        body:JSON.stringify({email, code:mfaCode})
      }).then(r=>r.json());
      setLoading(false);
      if (res.ok) setStep("done");
      else setMfaError(res.error||"Code invalide");
    } catch(e){ setLoading(false); setMfaError("Erreur serveur"); }
  };

  const inp = {background:"#0d1117",border:"1px solid #1e2a3a",borderRadius:10,padding:"12px 14px",color:"#fff",fontSize:14,outline:"none",width:"100%"};
  const btn = {padding:"13px",borderRadius:12,background:"linear-gradient(135deg,#5b6ef8,#a855f7)",border:"none",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer",width:"100%"};
  const btnOff = {...btn, background:"#1e2a3a", cursor:"not-allowed"};
  const lbl = {fontSize:11,fontWeight:700,color:"#5a6a7e",display:"block",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.5px"};

  return (
    <div style={{minHeight:"100vh",background:"#0d1117",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#161b27",border:"1px solid #1e2a3a",borderRadius:16,width:440,padding:36}}>
        <div style={{textAlign:"center",marginBottom:24}}>
          <div style={{fontSize:36,marginBottom:8}}>⚡</div>
          <div style={{fontSize:20,fontWeight:800,color:"#fff"}}>Support GS-GROUP</div>
        </div>

        {/* STEP 1 — Mot de passe */}
        {step==="password"&&(
          <div style={{display:"flex",flexDirection:"column",gap:16}}>
            {prenom&&<div style={{fontSize:15,color:"#fff",textAlign:"center",marginBottom:4}}>
              Bonjour <strong style={{color:"#5b6ef8"}}>{prenom}</strong>, créez votre mot de passe.
            </div>}
            <div><label style={lbl}>Nouveau mot de passe *</label>
              <input type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder="Minimum 8 caractères" style={inp}/>
            </div>
            <div><label style={lbl}>Confirmer *</label>
              <input type="password" value={conf} onChange={e=>setConf(e.target.value)} onKeyDown={e=>e.key==="Enter"&&createPassword()} placeholder="Répéter" style={inp}/>
            </div>
            {msg&&<div style={{padding:"10px",borderRadius:9,background:"#ef444420",border:"1px solid #ef4444",fontSize:13,color:"#ef4444",textAlign:"center"}}>{msg}</div>}
            <div style={{background:"#5b6ef815",border:"1px solid #5b6ef830",borderRadius:9,padding:"10px 14px",fontSize:12,color:"#8899bb"}}>
              🔐 Vous devrez ensuite configurer Google Authenticator (obligatoire).
            </div>
            <button onClick={createPassword} disabled={loading||!pass||!conf} style={pass&&conf?btn:btnOff}>
              {loading?"⏳ Création...":"Continuer →"}
            </button>
          </div>
        )}

        {/* STEP 2 — QR Code */}
        {step==="mfa"&&(
          <div style={{display:"flex",flexDirection:"column",gap:16}}>
            <div style={{background:"#f5a62315",border:"1px solid #f5a62340",borderRadius:12,padding:"12px",fontSize:13,color:"#f5a623",lineHeight:1.6,textAlign:"center"}}>
              <strong>Étape obligatoire</strong><br/>Scannez ce QR code avec Google Authenticator
            </div>
            {qr&&<div style={{textAlign:"center",background:"#fff",borderRadius:16,padding:16}}>
              <img src={qr} alt="QR MFA" style={{width:180,height:180}}/>
            </div>}
            <div style={{background:"#0d1117",borderRadius:10,padding:"10px 14px"}}>
              <div style={{fontSize:10,color:"#5a6a7e",marginBottom:4,textTransform:"uppercase"}}>Clé manuelle</div>
              <div style={{fontSize:11,fontFamily:"monospace",color:"#5b6ef8",wordBreak:"break-all"}}>{secret}</div>
            </div>
            <div style={{fontSize:12,color:"#5a6a7e",lineHeight:1.8}}>
              1. Installez <strong style={{color:"#fff"}}>Google Authenticator</strong><br/>
              2. Appuyez <strong style={{color:"#fff"}}>+</strong> → <strong style={{color:"#fff"}}>Scanner QR</strong><br/>
              3. Entrez le code ci-dessous
            </div>
            <div>
              <label style={lbl}>Code de vérification *</label>
              <input type="text" inputMode="numeric" maxLength={6} value={mfaCode}
                onChange={e=>setMfaCode(e.target.value.replace(/\D/g,""))}
                placeholder="000000"
                style={{...inp,textAlign:"center",fontSize:28,fontWeight:800,fontFamily:"monospace",letterSpacing:10}}/>
            </div>
            {mfaError&&<div style={{padding:"10px",borderRadius:9,background:"#ef444420",border:"1px solid #ef4444",fontSize:13,color:"#ef4444",textAlign:"center"}}>{mfaError}</div>}
            <button onClick={confirmMFA} disabled={mfaCode.length!==6||loading} style={mfaCode.length===6?btn:btnOff}>
              {loading?"⏳ Vérification...":"✅ Valider et activer mon compte"}
            </button>
          </div>
        )}

        {/* STEP 3 — Done */}
        {step==="done"&&(
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:56,marginBottom:16}}>🎉</div>
            <div style={{fontSize:18,fontWeight:800,color:"#22d3a0",marginBottom:8}}>Compte activé !</div>
            <div style={{fontSize:13,color:"#5a6a7e",marginBottom:24,lineHeight:1.7}}>
              Votre compte est sécurisé avec Google Authenticator.<br/>
              À chaque connexion, entrez le code de l'application.
            </div>
            <button onClick={()=>window.location.href="/"} style={btn}>
              Se connecter →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
